import React from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider } from 'antd'
import zh_TW from 'antd/lib/locale/zh_TW';
import { Provider } from 'react-redux'

//import 'antd/dist/antd.css'
import store from './redux/store'
import App from './App'

ReactDOM.render((
    <ConfigProvider locale={zh_TW}>
        <Provider store={store}>
            <App />
        </Provider>
    </ConfigProvider>), document.getElementById('root'))